export const KEYS = {
  shortlist: 'shortlist',
  currentStateEncoded: 'currentStateEncoded',
  currentStateEncodedTimestamp: 'currentStateEncodedTimestamp',
  recentHotels: 'recentHotels',
  recentSearches: 'recentSearches',
};

/* istanbul ignore next */
export function getItem(key) {
  if (typeof key === 'undefined') {
    throw new Error('LocalStorage key is undefined');
  }

  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    // This is to satisfy Safari in private mode: Message: SecurityError: DOM Exception 18
  }
}

/* istanbul ignore next */
export function setItem(key, value) {
  if (typeof key === 'undefined') {
    throw new Error('LocalStorage key is undefined');
  }

  if (typeof value !== 'string' && typeof value !== 'number') {
    throw new Error('LocalStorage value should be a string or a number');
  }

  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
    // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
    // to avoid the entire page breaking
  }
}

/* istanbul ignore next */
export function removeItem(key) {
  if (typeof key === 'undefined') {
    throw new Error('LocalStorage key is undefined');
  }

  if (window.localStorage && window.localStorage.removeItem) {
    window.localStorage.removeItem(key);
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/localStorage.js
 **/